export default __webpack_public_path__ + "static/SRUS P600 - Especification Del Producto y Datos Técnicos-09ec652f5f2f4cbcea5f535339187d95.pdf";